(function () {
  'use strict';

  if (customElements.get('orlea-sticky')) return;

  window.__orleaStickyTouched = window.__orleaStickyTouched || {};

  class OrleaSticky extends HTMLElement {
    connectedCallback() {
      if (window.matchMedia('(min-width: 900px)').matches) return;

      if (this.parentElement !== document.body) {
        var old = document.querySelector('body > orlea-sticky');
        if (old) old.remove();
        document.body.appendChild(this);
        return;
      }

      this._pid = this.dataset.productId || '';
      this._hasShades = this.dataset.hasShades === 'true';
      this._btn = this.querySelector('[data-osk-btn]');
      this._mainAtc = null;
      this._anchor = null;

      var info = this.closest('product-info') || document;
      this._anchor = info.querySelector('.orlea-pdp-atc');
      this._mainAtc = info.querySelector('.orlea-pdp-atc-btn .add_to_cart_button');
      if (!this._anchor || !this._btn) return;

      this._syncLabel();
      this._offsetPreviewBar();
      this._watchShades(info);
      this._observe();

      var self = this;
      this._btn.addEventListener('click', function () {
        if (self._needsShade()) {
          var shades = document.querySelector('.orlea-pdp-shades');
          if (shades) shades.scrollIntoView({ behavior: 'smooth', block: 'center' });
          return;
        }
        if (self._mainAtc && !self._mainAtc.disabled) self._mainAtc.click();
      });
    }

    disconnectedCallback() {
      if (this._io) this._io.disconnect();
    }

    _needsShade() {
      return this._hasShades && !window.__orleaStickyTouched[this._pid];
    }

    _watchShades(info) {
      var self = this;
      var radios = document.querySelectorAll('.orlea-pdp-shades input[type="radio"]');
      radios.forEach(function (r) {
        r.addEventListener('change', function () {
          window.__orleaStickyTouched[self._pid] = true;
          self._syncLabel();
        });
      });
    }

    _syncLabel() {
      var lbl = this._btn.querySelector('[data-osk-lbl]');
      if (!lbl) return;
      if (this._mainAtc && this._mainAtc.disabled) {
        lbl.textContent = this._btn.dataset.lblSoldout;
        this._btn.disabled = true;
      } else if (this._needsShade()) {
        lbl.textContent = this._btn.dataset.lblChoose;
        this._btn.disabled = false;
      } else {
        lbl.textContent = this._btn.dataset.lblAdd;
        this._btn.disabled = false;
      }
    }

    _offsetPreviewBar() {
      var pbar = document.getElementById('PBarNextFrameWrapper');
      this.style.bottom = pbar ? pbar.getBoundingClientRect().height + 'px' : '';
    }

    _observe() {
      var self = this;
      this._io = new IntersectionObserver(function (entries) {
        var e = entries[0];
        var passed = !e.isIntersecting && e.boundingClientRect.top < 0;
        if (passed) self._offsetPreviewBar();
        self.classList.toggle('osk-on', passed);
      }, { threshold: 0 });
      this._io.observe(this._anchor);
    }
  }

  customElements.define('orlea-sticky', OrleaSticky);
})();
